 
import * as React from 'react';

import { Typography } from 'omakase';
import SecondaryHeader from 'components/header/SecondaryHeader';

interface Props {
  children?: React.ReactChildren;
}

export const PreviewModeSecondaryHeader: React.FC<Props> = ({ children }) => {
  return (
    <SecondaryHeader variant="warning" align="center">
      <div className="MarketingSiteSecondaryHeader">
        <Typography variant="overline" color="fgContrast">
          Exploring Tock in Preview Mode
        </Typography>
        {children}
      </div>
    </SecondaryHeader>
  );
};
